import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { fetchStatus } from '../actions';

class StatusLoop extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.updateStatus = this.updateStatus.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchStatus());
    this.statusLoopInterval = setInterval(this.updateStatus, 180000);
  }

  componentWillUnmount() {
    clearInterval(this.statusLoopInterval);
  }

  updateStatus() {
    const { dispatch } = this.props;
    dispatch(fetchStatus());
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = (state) => ({
  status: state.status,
  loading: state.status.loading,
});

export default withRouter(connect(mapStateToProps)(StatusLoop));
